import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const TableDownstreamFlowsQueryGql: DocumentNode = gql`
query TableDownstreamFlowsQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: { id: $tableId }) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragment
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
